// extracted by mini-css-extract-plugin
module.exports = {"social":"_w","socialLink":"_x","service":"_y"};